import {
    linkGroup,
    Theme, Search as SearchType,
    links,
    searchSettings,
    themes
} from "../../data/data";

export const Search = {
    get: () => {
        const lsSearch = localStorage.getItem("search-settings");
        if (!!lsSearch)
            return Search.parse(lsSearch);
        return undefined;
    },
    getWithFallback: () => {
        try {
            return Search.get() || searchSettings;
        } catch {
            console.error("Your currently applied search settings appear to be corrupted.");
            return searchSettings;
        }
    },

    set: (searchSettings: SearchType) =>
        localStorage.setItem("search-settings", JSON.stringify(searchSettings)),

    parse: (searchSettings: string) =>
        JSON.parse(searchSettings) as SearchType,
};

export const Links = {
    getRaw: () => localStorage.getItem("link-groups"),
    get: () => {
        const lsLinks = localStorage.getItem("link-groups");
        if (!!lsLinks)
            return Links.parse(lsLinks);
        return undefined;
    },
    getWithFallback: () => {
        try {
            return Links.get() || links;
        } catch {
            console.error("Your currently applied links appear to be corrupted.");
            return links;
        }
    },

    set: (themes: linkGroup[]) =>
        localStorage.setItem("link-groups", JSON.stringify(themes)),

    parse: (linkGroups: string) =>
        JSON.parse(linkGroups) as linkGroup[],
};

export const Design = {
    get: () => {
        const lsDesign = localStorage.getItem("design");
        if (!!lsDesign)
            return Themes.parse(lsDesign);
        return undefined;
    },
    getWithFallback: () => {
        try {
            return Design.get() || themes[0];
        } catch {
            console.error("Your currently applied design appears to be corrupted.");
            return themes[0];
        }
    },

    set: (design: Theme) =>
        localStorage.setItem("design", JSON.stringify(design)),
};


export const Themes = {
    get: () => {
        const lsThemes = localStorage.getItem("themes");
        if (!!lsThemes)
            return JSON.parse(lsThemes) as Theme[];
        return undefined;
    },
    getWithFallback: () => {
        try {
            return Themes.get() || themes;
        } catch {
            console.error("Your currently applied themes appear to be corrupted.");
            return themes;
        }
    },

    set: (themes: Theme[]) =>
        localStorage.setItem("themes", JSON.stringify(themes)),


    add: (theme: Theme) => {
        const lsThemes = Themes.get();
        if (lsThemes)
            Themes.set([...lsThemes, theme])
        else
            Themes.set([theme])
    },

    remove: (name: string) => {
        const lsThemes = Themes.get();
        if (lsThemes)
            Themes.set(lsThemes.filter((theme) => theme.name !== name));
    },

    parse: (theme: string) =>
        JSON.parse(theme) as Theme,
};
